import { alpha, type Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

/**
 * Attention pulse for a just-added license card: a brand-green ring plus a
 * soft tint that fades out. Ends fully transparent, so removing it after the
 * run is invisible. Used by LicenseRequirementCard and the metadata-only
 * fallback card on the License Management page.
 */
export function newLicensePulseSx(theme: Theme): SystemStyleObject<Theme> {
  // Tests render with a default MUI theme that lacks the tint extension.
  const softTint = theme.palette.tint?.primarySoft ?? alpha(theme.palette.primary.main, 0.08);
  return {
    animation: 'license-added-pulse 2.4s cubic-bezier(0.22, 1, 0.36, 1) both',
    '@keyframes license-added-pulse': {
      '0%, 45%': {
        boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
        backgroundColor: softTint,
      },
      '100%': {
        boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0)}`,
        backgroundColor: theme.palette.background.paper,
      },
    },
  };
}
